import React from 'react';
import '../../App.css';

export default function BusSchedule() {
  return <h1 className='BusSchedule'>BusSchedule</h1>;
}
